import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="October 24, 2026" testId="terms-page">
      <LegalSection heading="Agreement">
        <p>
          These Terms of Service govern your use of this website, operated by WorkSafeAgent LLC
          ("we", "us", "our"). By using this site, you agree to these terms. They are governed by
          the laws of the State of Texas.
        </p>
      </LegalSection>

      <LegalSection heading="What this site is">
        <p>
          This website provides general information about WSafe AI Mobile and the other products in
          the WorkSafeAgent family. Any subscription, pilot, evaluation, or consulting engagement is
          covered by a separate agreement between you and WorkSafeAgent LLC.
        </p>
      </LegalSection>

      <LegalSection heading="Acceptable use">
        <p>
          You agree to use this site lawfully and not to interfere with its operation, attempt to
          access systems you are not authorized to use, or misrepresent who you are when contacting
          us.
        </p>
      </LegalSection>

      <LegalSection heading="Intellectual property">
        <p>
          The content on this site, including text, design, logos, and product names, belongs to
          WorkSafeAgent LLC or its licensors. You may not copy or reuse it without our written
          permission, except for sharing a link to this site.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party links">
        <p>
          This site links to third-party websites and services, including scheduling and product
          sites. We do not control those sites and are not responsible for their content or
          practices.
        </p>
      </LegalSection>

      <LegalSection heading="No warranties">
        <p>
          This website is provided "as is" and "as available". We make no warranties, express or
          implied, about the site or its content, including any implied warranties of
          merchantability or fitness for a particular purpose.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of liability">
        <p>
          To the fullest extent permitted by law, WorkSafeAgent LLC will not be liable for any
          indirect, incidental, or consequential damages arising from your use of this website.
        </p>
      </LegalSection>

      <LegalSection heading="Governing law and disputes">
        <p>
          These terms are governed by the laws of the State of Texas, without regard to conflict of
          law rules. Any dispute relating to this site will be brought in the state or federal
          courts located in Texas.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to these terms">
        <p>
          We may update these terms from time to time. The current version will always be posted on
          this page with the date above.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions about these terms? Email us at{" "}
          <a
            href="mailto:info@wsafeai.com"
            data-testid="terms-email-link"
            className="font-medium text-safety hover:text-safety-dark"
          >
            info@wsafeai.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
